var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.034 0.473633C7.35065 0.473633 0.333984 8.37363 0.333984 17.1403C0.333984 19.9403 1.15065 22.8236 2.58398 25.457C2.85065 25.8903 2.88398 26.4403 2.70065 26.957L1.58398 30.6903C1.33398 31.5903 2.10065 32.257 2.95065 31.9903L6.31732 30.9903C7.23398 30.6903 7.95065 31.0736 8.80232 31.5903C11.2357 33.0236 14.2673 33.757 17.0007 33.757C25.2673 33.757 33.6673 27.3736 33.6673 17.0903C33.6673 8.22363 26.5007 0.473633 17.034 0.473633Z",
    fill: "#CC2B52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9677 19.2903C15.7844 19.2737 14.8344 18.3237 14.8344 17.1403C14.8344 15.9737 15.8011 15.007 16.9677 15.0236C18.1511 15.0236 19.1011 15.9737 19.1011 17.157C19.1011 18.3237 18.1511 19.2903 16.9677 19.2903ZM9.28372 19.2902C8.11706 19.2902 7.15039 18.3236 7.15039 17.1569C7.15039 15.9736 8.10039 15.0236 9.28372 15.0236C10.4671 15.0236 11.4171 15.9736 11.4171 17.1569C11.4171 18.3236 10.4671 19.2736 9.28372 19.2902ZM22.5174 17.157C22.5174 18.3237 23.4674 19.2903 24.6507 19.2903C25.8341 19.2903 26.7841 18.3237 26.7841 17.157C26.7841 15.9737 25.8341 15.0237 24.6507 15.0237C23.4674 15.0237 22.5174 15.9737 22.5174 17.157Z",
    fill: "#CC2B52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/Chat.629687b3ad59b9081c224ec539605726.svg";
export { ForwardRef as ReactComponent };